import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '-1rem',
    width: 'calc(100% - 72px)',
    height: 'calc(100% - 76px + 2rem)',

    [theme.breakpoints.down(450)]: {
      width: 'calc(100% - 2rem)'
    }
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: '27px',

    '& > *': {
      marginTop: '1rem'
    }
  },

  title: {
    marginRight: '16px',
    maxWidth: '390px',
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  },

  search: {
    width: '100%',
    maxWidth: '360px',

    [theme.breakpoints.down(380)]: {
      maxWidth: 'calc(100vw - 42px)'
    }
  },

  buttons: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: ({ extraPadding }) => (extraPadding ? 28 : 20)
  },

  button: {
    width: 'auto',
    height: '28px',
    fontSize: theme.size.sm
  },

  folderButton: {
    marginRight: '8px'
  },

  table: {
    flex: '1',
    overflow: 'auto',
    maxHeight: 'calc(100svh - 200px)',
    '& div[role=rowheader]': {},
    '& div[role=row]': {
      display: 'flex'
    }
  },

  tableHeader: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 1rem',
    backgroundColor: '#F8D8FF',
    borderRadius: '4px 4px 0px 0px',
    color: '#B64FCD',
    height: 36,
    borderBottom: 'solid 1px #B64FCD',

    '& > div': {}
  },

  tableHeaderCell: {},

  roleGroup: {
    margin: '0px 1rem'
  }
}))

export default useStyles
